export const modes = [
	{
		label: "Topup Mode",
		value: "TRANSFER",
	},
	{
		label: "Wallet Mode",
		value: "SEAMLESS",
	},
];

export const modeTypes = {
	TRANSFER: "TRANSFER",
	SEAMLESS: "SEAMLESS",
	HYBRID: "HYBRID",
};
